import { useEffect, useRef, useState } from "react";

export default function useFaqScroll(faqs) {
    const sectionRefs = useRef({});
    const [activeSection, setActiveSection] = useState(
        faqs[0]?.title
    );

    const scrollToSection = (title) => {
        setActiveSection(title); // 🔥 THIS is missing
        sectionRefs.current[title]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = Object.entries(sectionRefs.current);

            for (const [title, el] of sections) {
                if (!el) continue;

                const rect = el.getBoundingClientRect();
                if (rect.top <= 120 && rect.bottom >= 120) {
                    setActiveSection(title);
                    break;
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return { activeSection, sectionRefs, scrollToSection };
}
